"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const axios_1 = __importDefault(require("axios"));
const Field_1 = __importDefault(require("../models/Field"));
const Crop_1 = __importDefault(require("@becrop/abstract/Models/Crop"));
class VardaService {
    constructor() {
        this.fields = [];
    }
    async getFields(url) {
        try {
            const response = await axios_1.default.get(url);
            if (Array.isArray(response.data)) {
                response.data.forEach((field) => {
                    this.fields = this.fields.filter(existingField => response.data.some((field) => field.vardaFieldId === existingField.id));
                    const fieldModel = new Field_1.default({
                        id: field.vardaFieldId,
                        fieldName: field.fieldName,
                        farmId: -1,
                        farmName: '',
                        size: field.extension,
                        sizeUnit: field.extension_units,
                        managementPractice: null,
                        crop: new Crop_1.default({
                            id: -1,
                            name: '-',
                            color: '#eebb54',
                            icon: '-'
                        }),
                        geodata: field.geometry,
                        origin: '',
                        metadata: [],
                        projection: '',
                        quoteId: -1,
                        provider: 'setup-varda',
                        providerFieldId: field.vardaFieldId
                    });
                    const exists = this.fields.some(existingField => existingField.id === fieldModel.id);
                    if (!exists)
                        this.fields.push(fieldModel);
                });
            }
        }
        catch (error) {
            console.error(error);
        }
    }
}
exports.default = VardaService;
